// extracted by mini-css-extract-plugin
module.exports = {"dragContainer":"styles__dragContainer___3OM6X","dragIcon":"styles__dragIcon___2WHgF","dragInput":"styles__dragInput___2XetU"};